<template>
  <div class="container">
    <v-row class="buttonBackConteiner no-print" v-if="canStepBack">
      <QuotationBackButton
        class="buttonBack"
        v-if="currentQuotation.cancelada_em == null"
        @back="previousStep"
      />
      <v-spacer />
    </v-row>
    <v-row v-if="!getIsEmployeeUser" class="containerRow">
      <v-row class="containerInfoMessageGuest" v-if="getUserIsGuest">
        <QuotationFloatActionButton :message="infoMessageGuest" />
      </v-row>
      <v-row class="containerInfoMessageUser" v-if="!getUserIsGuest">
        <QuotationFloatActionButton :message="infoMessageUser" />
      </v-row>
      <v-row class="containerStatusMessage text-center" v-if="!getUserIsGuest">
        <QuotationStatusMessage
          title="Aguarde, sua cotação está sendo gerada!"
          text="Iremos lhe enviar um e-mail quando este passo for concluído."
        />
      </v-row>
      <v-row v-if="getUserIsGuest" class="containerGuest">
        <v-col class="text-center">
          <QuotationGuestWarning :userEmail="formCosts.email" />
        </v-col>
      </v-row>
    </v-row>
    <div>
      <QuotationCostsForm
        :formCost="formCosts"
        @submit="submit"
        @cancel="cancelQuotationButton"
        v-if="!getUserIsGuest"
        v-model="formCosts"
        value="formCosts"
        :options-quotation="optionsQuotation"
        :modality="modality"
      />
    </div>
  </div>
</template>
<script>
import QuotationCostsForm from "../components_agro/QuotationCostsForm";
import QuotationGuestWarning from "../components_agro/QuotationGuestWarning";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { mapState } from "vuex";
import QuotationStatusMessage from "../components_agro/QuotationStatusMessage";

export default {
  name: "QuotationStepCosts",
  data: () => ({
    formCosts: {}
  }),
  components: {
    QuotationStatusMessage,
    QuotationCostsForm,
    QuotationGuestWarning,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("me", ["userIsEmployee", "userIsGuest", "myInfo"]),
    ...mapState("quotation", ["currentQuotation"]),
    nextQuotationStep() {
      return {
        name: "quotation step aproveCosts",
        step: 5
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step insured",
        step: 3
      };
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessageGuest() {
      let userGuestMessage =
        "Sua solicitação foi criada com sucesso. Para acessar as cotações, crie uma senha através do e-mail que enviamos.";
      return userGuestMessage;
    },
    infoMessageUser() {
      let userMessage =
        "Solicitação criada com sucesso. Em breve as cotações estarão disponíveis aqui.";
      return userMessage;
    },
    canStepBack() {
      return this.myInfo.id == this.currentQuotation.criada_por.id;
    }
  },
  created() {
    this.formCosts = { ...this.form };
  },
  methods: {
    getFormForNavigation() {
      return this.formCosts;
    },
    submit(form) {
      let nextStep = this.nextQuotationStep;
      this.$emit("updateStep", this.payloadQuotation(form, nextStep));
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formCosts, this.previousQuotationStep)
      );
    },
    cancelQuotationButton() {
      this.$emit("cancel");
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formCost: {
      type: Object
    },
    modality: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.container
  width: 100% !important
  margin: 0 auto !important
.containerRow
  display: flex
  flex-direction: column
.containerInfoMessageUser
  display: flex
  justify-content: flex-end
  margin-top: -67px
  margin-right: 90px
.containerGuest
  display: flex
  align-items: center
  align-content: center
  margin-top: 80px
.containerInfoMessageGuest
  display: flex
  justify-content: flex-end
  margin-top: -70px
  margin-right: 90px
.containerStatusMessage
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
</style>
